import { render, staticRenderFns } from "./EpFaq.vue?vue&type=template&id=a1302446"
import script from "./EpFaq.vue?vue&type=script&lang=js"
export * from "./EpFaq.vue?vue&type=script&lang=js"
import style0 from "./EpFaq.vue?vue&type=style&index=0&id=a1302446&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports